import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

import './HeatmapSettingsButton.scss';

export default function HeatmapSettingsButton({ openHeatmapSettingsDialog }) {
  return (
    <Button
      onClick={openHeatmapSettingsDialog}
      buttonConfig={{
        className: 'result-toolbar-heatmap-settings-button',
        label: 'Settings',
        type: 'link',
        size: 'tiny',
        e2eName: 'heatmap-settings',
      }}
      iconConfig={{
        position: 'before',
        name: 'settings',
        size: 'sm',
      }}
    />
  );
}

HeatmapSettingsButton.propTypes = {
  openHeatmapSettingsDialog: PropTypes.func.isRequired,
};
